import { render } from "./FormCascader.vue?vue&type=template&id=5b51c22d&scoped=true"
import script from "./FormCascader.vue?vue&type=script&lang=js"
export * from "./FormCascader.vue?vue&type=script&lang=js"

import "./FormCascader.vue?vue&type=style&index=0&id=5b51c22d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b51c22d"]])

export default __exports__